import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const deleteAuction = async (id, context = {}) => {
  if (!id) {
    console.error('ID de subasta no proporcionado');
    return { success: 'no', message: 'ID de subasta no proporcionado' };
  }

  try {
    const deleteAuctionFn = httpsCallable(functions, 'deleteAuctionV2');
    const result = await deleteAuctionFn({
      auctionId: id,
      operatingUnitId: context.activeUnitId,
      dealershipId: context.dealershipId,
      requestedApp: 'dealership_web',
    });
    return result.data;
  } catch (error) {
    console.error('Error al eliminar subasta:', error);
    notifyPermissionDenied(error);
    return { success: 'no', message: error.message };
  }
};
